module.exports = __webpack_public_path__ + "img/LPN_Sword_Cyber_Greenway.33142b50.png";